import React from "react"
import { createIcon } from "@chakra-ui/react"

export const LayerPlus = createIcon({
  displayName: "LayerPlus",
  viewBox: "0 0 576 512",
  path: (
    <path d="M488 24V0H440V24 56H408 384v48h24 32v32 24h48V136 104h32 24V56H520 488V24zM0 256L288 384 576 256 288 128 0 256zM288 419L104.6 337.5 0 384 288 512 576 384 471.4 337.5 288 419z" />
  ),
})
